import React, { useCallback } from 'react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { changeAlignment } from '../editor-commands';
import { ToolbarType } from '../pm-plugins/types';
import ToolbarAlignment from './ToolbarAlignment';
var FloatingToolbarSettings = {
  disabled: false,
  isToolbarReducedSpacing: true
};
export function FloatingToolbarComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView;
  var _useSharedPluginState = useSharedPluginState(api, ['alignment'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    alignmentState = _useSharedPluginState.alignmentState;
  var alignSelector = useSharedPluginStateSelector(api, 'alignment.align', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var align = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? alignSelector : alignmentState === null || alignmentState === void 0 ? void 0 : alignmentState.align;
  var isEnabledSelector = useSharedPluginStateSelector(api, 'alignment.isEnabled', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var isEnabled = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? isEnabledSelector : alignmentState === null || alignmentState === void 0 ? void 0 : alignmentState.isEnabled;
  var changeAlignmentCallback = useCallback(function (align) {
    return changeAlignment(align, api, INPUT_METHOD.FLOATING_TB)(editorView.state, editorView.dispatch);
  }, [editorView, api]);
  return /*#__PURE__*/React.createElement(ToolbarAlignment, {
    align: align,
    isReducedSpacing: editorExperiment('platform_editor_controls', 'variant1') ? false : FloatingToolbarSettings.isToolbarReducedSpacing,
    changeAlignment: changeAlignmentCallback,
    disabled: FloatingToolbarSettings.disabled || !isEnabled,
    toolbarType: ToolbarType.FLOATING,
    api: api
  });
}